// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.PauseDialogue_dialogueBox__nydGb {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 400px;
  flex-shrink: 0;
  border-radius: 8px;
  background: var(--background-secondary, #fff);
  /* ◻️ Light/action_shadow */
  box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.05);
  z-index: 1000;
  padding: 20px;
}

.PauseDialogue_topHeading__lBz2V {
  color: var(--text-primary, #1f2023);
  /* Subheadline/Bold */
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px; /* 125% */
  letter-spacing: -0.5px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
}
.PauseDialogue_topHeading__lBz2V span {
  display: flex;
  gap: 10px;
}

.PauseDialogue_inputBox__TlNl6 {
  border-bottom: 1px solid var(--border-secondary, #c8d3e0);
  margin-bottom: 40px;
  display: flex;
  gap: 7px;
  align-items: center;
  padding-left: 15px;
}
.PauseDialogue_inputBox__TlNl6 label {
  color: var(--text-secondary, #5c6168);
  /* Caption 1/Regular */
  font-family: Poppins;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 138.462% */
  letter-spacing: -0.2px;
}
.PauseDialogue_inputBox__TlNl6 input {
  color: var(--text-primary, #1f2023);
  /* Caption 1/Regular */
  font-family: Poppins;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 138.462% */
  letter-spacing: -0.2px;
  width: 100%;
  display: flex;
  padding: 11px 8px;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
}

.PauseDialogue_btnBox__gLOmo {
  display: flex;
  justify-content: end;
}
.PauseDialogue_btnBox__gLOmo button {
  display: flex;
  padding: 7px 8px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 8px;
  background: var(--primary-default, #0c6dc7);
  color: var(--text-on-color, #fff);
  font-family: Poppins;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px; /* 138.462% */
  letter-spacing: -0.5px;
}

.PauseDialogue_closeBox__lTLlt {
  cursor: pointer;
}

.PauseDialogue_disabled__WjTQ\\+ {
  cursor: default;
  background: var(--primary-disabled, #c8d3e0) !important;
}

@media only screen and (max-width: 500px) {
  .PauseDialogue_dialogueBox__nydGb {
    top: unset;
    bottom: 0;
    left: 0;
    transform: unset;
    width: 100%;
  }
  .PauseDialogue_btnBox__gLOmo button {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Sidecar/ActionsDialogue/PauseDialogue/PauseDialogue.module.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACC,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EAEA,YAAA;EAEA,cAAA;EACA,kBAAA;EACA,6CAAA;EAEA,2BAAA;EACA,gDAAA;EACA,aAAA;EAEA,aAAA;AAFD;;AAOA;EACC,mCAAA;EAEA,qBAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;EACA,sBAAA;EAEA,aAAA;EACA,8BAAA;EAEA,mBAAA;AAPD;AASC;EACC,aAAA;EACA,SAAA;AAPF;;AAWA;EACC,yDAAA;EAEA,mBAAA;EAEA,aAAA;EACA,QAAA;EACA,mBAAA;EAEA,kBAAA;AAXD;AAaC;EACC,qCAAA;EAEA,sBAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,aAAA;EACA,sBAAA;AAZF;AAeC;EACC,mCAAA;EAEA,sBAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,aAAA;EACA,sBAAA;EAEA,WAAA;EAEA,aAAA;EACA,iBAAA;EACA,uBAAA;EACA,QAAA;EACA,mBAAA;AAhBF;;AAoBA;EACC,aAAA;EACA,oBAAA;AAjBD;AAmBC;EACC,aAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;EAEA,kBAAA;EACA,2CAAA;EAEA,iCAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,aAAA;EACA,sBAAA;AAnBF;;AAuBA;EACC,eAAA;AApBD;;AAsBA;EACC,eAAA;EACA,uDAAA;AAnBD;;AAsBA;EACC;IACC,UAAA;IACA,SAAA;IACA,OAAA;IACA,gBAAA;IACA,WAAA;EAnBA;EAuBA;IACC,WAAA;EArBD;AACF","sourcesContent":[".dialogueBox {\n\tposition: absolute;\n\ttop: 50%;\n\tleft: 50%;\n\ttransform: translate(-50%, -50%);\n\n\twidth: 400px;\n\t// height: 100%;\n\tflex-shrink: 0;\n\tborder-radius: 8px;\n\tbackground: var(--background-secondary, #fff);\n\n\t/* ◻️ Light/action_shadow */\n\tbox-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.05);\n\tz-index: 1000;\n\n\tpadding: 20px;\n\n\t// position: relative;\n}\n\n.topHeading {\n\tcolor: var(--text-primary, #1f2023);\n\n\t/* Subheadline/Bold */\n\tfont-family: Poppins;\n\tfont-size: 16px;\n\tfont-style: normal;\n\tfont-weight: 600;\n\tline-height: 20px; /* 125% */\n\tletter-spacing: -0.5px;\n\n\tdisplay: flex;\n\tjustify-content: space-between;\n\n\tmargin-bottom: 30px;\n\n\tspan {\n\t\tdisplay: flex;\n\t\tgap: 10px;\n\t}\n}\n\n.inputBox {\n\tborder-bottom: 1px solid var(--border-secondary, #c8d3e0);\n\n\tmargin-bottom: 40px;\n\n\tdisplay: flex;\n\tgap: 7px;\n\talign-items: center;\n\n\tpadding-left: 15px;\n\n\tlabel {\n\t\tcolor: var(--text-secondary, #5c6168);\n\n\t\t/* Caption 1/Regular */\n\t\tfont-family: Poppins;\n\t\tfont-size: 13px;\n\t\tfont-style: normal;\n\t\tfont-weight: 400;\n\t\tline-height: 18px; /* 138.462% */\n\t\tletter-spacing: -0.2px;\n\t}\n\n\tinput {\n\t\tcolor: var(--text-primary, #1f2023);\n\n\t\t/* Caption 1/Regular */\n\t\tfont-family: Poppins;\n\t\tfont-size: 13px;\n\t\tfont-style: normal;\n\t\tfont-weight: 400;\n\t\tline-height: 18px; /* 138.462% */\n\t\tletter-spacing: -0.2px;\n\n\t\twidth: 100%;\n\n\t\tdisplay: flex;\n\t\tpadding: 11px 8px;\n\t\talign-items: flex-start;\n\t\tgap: 8px;\n\t\talign-self: stretch;\n\t}\n}\n\n.btnBox {\n\tdisplay: flex;\n\tjustify-content: end;\n\n\tbutton {\n\t\tdisplay: flex;\n\t\tpadding: 7px 8px;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tgap: 4px;\n\n\t\tborder-radius: 8px;\n\t\tbackground: var(--primary-default, #0c6dc7);\n\n\t\tcolor: var(--text-on-color, #fff);\n\t\tfont-family: Poppins;\n\t\tfont-size: 13px;\n\t\tfont-style: normal;\n\t\tfont-weight: 500;\n\t\tline-height: 18px; /* 138.462% */\n\t\tletter-spacing: -0.5px;\n\t}\n}\n\n.closeBox {\n\tcursor: pointer;\n}\n.disabled{\n\tcursor: default;\n\tbackground: var(--primary-disabled, #c8d3e0) !important;\n}\n\n@media only screen and (max-width: 500px) {\n\t.dialogueBox {\n\t\ttop: unset;\n\t\tbottom: 0;\n\t\tleft: 0;\n\t\ttransform: unset;\n\t\twidth: 100%;\n\t}\n\n\t.btnBox {\n\t\tbutton {\n\t\t\twidth: 100%;\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dialogueBox": `PauseDialogue_dialogueBox__nydGb`,
	"topHeading": `PauseDialogue_topHeading__lBz2V`,
	"inputBox": `PauseDialogue_inputBox__TlNl6`,
	"btnBox": `PauseDialogue_btnBox__gLOmo`,
	"closeBox": `PauseDialogue_closeBox__lTLlt`,
	"disabled": `PauseDialogue_disabled__WjTQ+`
};
export default ___CSS_LOADER_EXPORT___;
